<template>
    <button class="filter-button"
        :class="additionalCssClasses">
        <span v-if="number"
            class="filter-button__number">{{ number }}</span>
        {{ label }}
        <base-material-design-icon class="filter-button__icon"
            icon="arrowDown" />
    </button>
</template>

<script>
const BUTTON_TYPES = {
    primary: 'primary',
    secondary: 'secondary'
}

export default {
    name: 'FilterButton',
    props: {
        label: String,
        // number of selected filter values to be displayed before label
        number: Number,
        active: Boolean,
        type: {
            type: String,
            validator: function (value) {
                return Object.values(BUTTON_TYPES).includes(value);
            }
        }
    },
    data() {
        return {
            buttonType: BUTTON_TYPES.primary,
        }
    },
    watch: {
        type(value) {
            if (!value || value === BUTTON_TYPES.secondary) {
                this.buttonType = BUTTON_TYPES.secondary;
            } else {
                this.buttonType = BUTTON_TYPES.primary;
            }
        }
    },
    computed: {
        additionalCssClasses() {
            const baseClass = 'filter-button'
            let result = `${baseClass}_${this.buttonType}`;
            
            if (this.active) {
                result += ` ${baseClass}_active`;
            }

            return result;
        }
    }
}
</script>

<style lang="scss"> 
    .filter-button {
        padding: 4px 8px 4px 12px;
        border-radius: 20px;
        background-color: transparent;
        border-width: 1px;
        border-style: solid;
        display: flex;
        align-items: center;
        gap: 4px;
        font-size: 14px;
        line-height: 16px;
        color: $rfx-medium-march;

        &_primary {
            border-color: $rfx-medium-steel;

            &:hover {
                border-color: $rfx-darker-steel;
            }

            &.filter-button {
                &_active {
                    border-color: $rfx-quarter-march;
                    background-color: $rfx-quarter-march;
                    color: #fff;

                    &:hover {
                        border-color: $rfx-medium-march;
                        background-color: $rfx-medium-march;
                    }
                }
            }
        }

        &_secondary {
            border-color: transparent;
            color: $rfx-quarter-march;

            &:hover {
                color: $rfx-medium-march;
            }
        }

        &__number {
            display: block;
            padding: 0 4px;
        }

        &__icon {
            height: 20px;
            width: 20px;
            color: inherit;
        }
    }
</style>